import { render, staticRenderFns } from "./info2.vue?vue&type=template&id=b6f4341a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "info2.vue"
export default component.exports